// extracted by mini-css-extract-plugin
module.exports = {"RecommendKeywordList":"RecommendKeyword_RecommendKeywordList__OL_X_","left":"RecommendKeyword_left__S4tXi"};